module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/news-c3f047159bf9dd127d1290740d7a9295.png";